import {
    CheckCircle2,
    XCircle,
    Trash2,
    Star,
    Flame,
    Clock3,
} from "lucide-react";

import "./FoodActions.css";

function FoodActions({
    food,
    onEnable,
    onDisable,
    onDelete,
}) {

    if (!food) return null;

    const handleDelete = () => {

        const confirmDelete = window.confirm(
            `Delete "${food.foodName}" ?`
        );

        if (!confirmDelete) return;

        onDelete(food._id);

    };

    return (

        <div className="food-actions-panel">

            <h3>

                Food Actions

            </h3>

            <div className="food-status-grid">

                <div className="status-card">

                    <strong>Availability</strong>

                    <span
                        className={
                            food.isAvailable
                                ? "badge success"
                                : "badge danger"
                        }
                    >

                        {food.isAvailable
                            ? "Available"
                            : "Unavailable"}

                    </span>

                </div>

                <div className="status-card">

                    <strong>Approval</strong>

                    <span className="badge info">

                        {food.approvalStatus}

                    </span>

                </div>

                <div className="status-card">

                    <strong>Status</strong>

                    <span className="badge secondary">

                        {food.status}

                    </span>

                </div>

            </div>

            <div className="food-highlights">

                {food.isFeatured && (

                    <span className="highlight featured">

                        <Star size={14} />

                        Featured

                    </span>

                )}

                {food.isBestSeller && (

                    <span className="highlight bestseller">

                        <Flame size={14} />

                        Best Seller

                    </span>

                )}

                {food.isTodaysSpecial && (

                    <span className="highlight special">

                        <Clock3 size={14} />

                        Today's Special

                    </span>

                )}

            </div>

            <div className="food-action-buttons">

                {food.isAvailable ? (

                    <button
                        className="disable-btn"
                        onClick={() =>
                            onDisable(food._id)
                        }
                    >

                        <XCircle size={18} />

                        Disable Food

                    </button>

                ) : (

                    <button
                        className="enable-btn"
                        onClick={() =>
                            onEnable(food._id)
                        }
                    >

                        <CheckCircle2 size={18} />

                        Enable Food

                    </button>

                )}

                <button
                    className="delete-btn"
                    onClick={handleDelete}
                >

                    <Trash2 size={18} />

                    Delete Food

                </button>

            </div>

        </div>

    );

}

export default FoodActions;